import initialState from './initialState';
import * as types from './actionTypes';

const faqReducer = (state = initialState.faqs, action) => {
  switch (action.type) {
    case types.SET_SUPPORT_CONTENT: {
      const supportContent = action.supportContent || {};
      const { faqs } = supportContent;
      return [...faqs];
    }
    default:
      return state;
  }
};

const videoReducer = (state = initialState.videos, action) => {
  switch (action.type) {
    case types.SET_SUPPORT_CONTENT: {
      const supportContent = action.supportContent || {};
      const { videos } = supportContent;
      return [...videos];
    }
    default:
      return state;
  }
};

const contentServiceRequestIdReducer = (state = initialState.contentServiceRequestId, action) => {
  switch (action.type) {
    case types.SET_SUPPORT_CONTENT: {
      const supportContent = action.supportContent || {};
      const { requestId } = supportContent;
      return requestId;
    }
    default:
      return state;
  }
};

const isSupportMenuOpenReducer = (state = initialState.isSupportMenuOpen, action) => {
  switch (action.type) {
    case types.SET_SUPPORT_MENU_STATE: {
      const { isOpen } = action;
      return isOpen;
    }
    default:
      return state;
  }
};

const isMobileSupportMenuOpenReducer = (state = initialState.isMobileSupportMenuOpen, action) => {
  switch (action.type) {
    case types.SET_MOBILE_SUPPORT_MENU_STATE: {
      const { payload } = action;
      return payload.isOpen;
    }
    default:
      return state;
  }
};

const isSupportContentLoading = (state = initialState.isSupportContentLoading, action) => {
  switch (action.type) {
    case types.SET_SUPPORT_CONTENT_LOADING: {
      return true;
    }
    case types.SET_SUPPORT_CONTENT: {
      return false;
    }
    default:
      return state;
  }
};

const focusedVideoIdReducer = (state = initialState.focusedVideoId, action) => {
  switch (action.type) {
    case types.SET_FOCUSED_VIDEO_ID: {
      const { videoId } = action;
      return videoId;
    }
    default:
      return state;
  }
};

const supportHoursReducer = (state = initialState.supportHours, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default {
  faqReducer,
  videoReducer,
  contentServiceRequestIdReducer,
  isSupportMenuOpenReducer,
  isSupportContentLoading,
  isMobileSupportMenuOpenReducer,
  supportHoursReducer,
  focusedVideoIdReducer,
};
